import React from 'react';

export default function StatCard({ label, value, sub, color = '#6c5ce7', large }) {
  return (
    <div style={styles.card}>
      <div style={{ ...styles.accent, background: color }} />
      <div style={styles.label}>{label}</div>
      <div style={{ ...styles.value, fontSize: large ? 36 : 28 }}>{value}</div>
      {sub && <div style={styles.sub}>{sub}</div>}
    </div>
  );
}

const styles = {
  card: {
    background: '#fff',
    borderRadius: 10,
    padding: '18px 20px',
    position: 'relative',
    overflow: 'hidden',
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
    minWidth: 150,
  },
  accent: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: 3,
    borderRadius: '10px 10px 0 0',
  },
  label: {
    fontSize: 12,
    color: '#636e72',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: 6,
  },
  value: {
    fontWeight: 700,
    color: '#2d3436',
    lineHeight: 1.1,
  },
  sub: {
    fontSize: 12,
    color: '#636e72',
    marginTop: 4,
  },
};
